// extracted by mini-css-extract-plugin
module.exports = {"winWrapper":"WinMsg_winWrapper__30N7F","bgVideo":"WinMsg_bgVideo__1chyM","background":"WinMsg_background__2iq5l","winBox":"WinMsg_winBox__2aJVC"};